import { Text } from "@ui-kitten/components";
import { PlanPackageDetails, SignupChargeDetails } from "features/types";
import useSignupCharge from "hooks/useSignupCharge";
import React, { useMemo, useState } from "react";
import { View } from "react-native";
import PriceText from "screens/Reserve/components/PriceText";
import Dialog from "./Dialog";
import { formatCurrency } from "utils/appUtils";

interface OrderSummaryProps {
  signupCharge: SignupChargeDetails;
  planPackage: PlanPackageDetails;
}
function OrderSummary({ signupCharge, planPackage }: OrderSummaryProps) {
  const [visible, setVisible] = useState(false);
  const { totalCharge } = useSignupCharge(signupCharge);
  const { signupFees } = signupCharge;

  const getTotalFeesAmount = useMemo(() => {
    if (!signupFees) return 0;
    return signupFees.reduce((acc, fee) => {
      acc += Number(fee.feeAmount);
      return acc;
    }, 0);
  }, [signupFees]);

  const getDescriptionByFeeName = (feeName: string) => {
    return signupFees?.find((fee) => fee.structureDetails.name === feeName)
      ?.structureDetails.description;
  };

  const feesRecord = signupFees?.reduce((acc: Record<string, number>, fee) => {
    if (acc[fee.structureDetails.name] === undefined) {
      acc[fee.structureDetails.name] = Number(fee.feeAmount);
    } else {
      acc[fee.structureDetails.name] += Number(fee.feeAmount);
    }
    return acc;
  }, {});

  return (
    <View>
      <Text category="h6">Order Summary</Text>
      <View>
        <>
          {/* show subtotal and fees only if allInclusivePrice is false 
            https://github.com/FanRally/fanrally-core/issues/1414
          */}
          {!planPackage.allInclusivePrice && (
            <>
              <PriceText
                label="Subtotal"
                text={formatCurrency(signupCharge.signupCharge)}
              ></PriceText>
              {getTotalFeesAmount > 0 && (
                <PriceText
                  label="Fees & Estimated Taxes"
                  text={formatCurrency(getTotalFeesAmount)}
                  showInfo
                  onInfoPress={() => setVisible(true)}
                ></PriceText>
              )}
            </>
          )}
        </>

        <PriceText label="Total" text={formatCurrency(totalCharge)}></PriceText>
      </View>
      <Dialog visible={visible} onOk={() => setVisible(false)} okText="Got it!">
        <View>
          <Text category="h6" style={{ marginBottom: 8 }}>
            Fees & Estimated Taxes
          </Text>
          {Object.keys(feesRecord || {}).map((feeName) => (
            <View key={feeName} className="mb-4">
              <View className="flex-row gap-2">
                <Text>{feeName}:</Text>
                {feesRecord && (
                  <Text style={{ fontWeight: "600" }}>
                    {formatCurrency(feesRecord[feeName])}
                  </Text>
                )}
              </View>
              <Text category="c1">{getDescriptionByFeeName(feeName)}</Text>
            </View>
          ))}
          {/* {signupFees?.map((fee) => (
            <View key={fee.structureDetails.id} className=" mb-4">
              <View className="flex-row gap-2">
                <Text>{fee.structureDetails.name}:</Text>
                <Text style={{ fontWeight: "600" }}>
                  {formatCurrency(fee.feeAmount)}
                </Text>
              </View>
              <Text category="c1">{fee.structureDetails.description}</Text>
            </View>
          ))} */}
        </View>
      </Dialog>
    </View>
  );
}

export default OrderSummary;
